module.exports = __webpack_public_path__ + "media/images/emblems/Uster-blazon-23023797b6d9d4a455a96a9731ae1d58.svg";